import { render } from "./AdminPaymentManagement.vue?vue&type=template&id=66fb5aa4&scoped=true"
import script from "./AdminPaymentManagement.vue?vue&type=script&lang=js"
export * from "./AdminPaymentManagement.vue?vue&type=script&lang=js"

import "./AdminPaymentManagement.vue?vue&type=style&index=0&id=66fb5aa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66fb5aa4"]])

export default __exports__